import React from 'react';
import { Icon } from './Icon.js';
export const IconChevronRightSm = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M10.5 8L14.5 12L10.5 16", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChevronRightSm.js.map